import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// const resources = {
//   en: {
//     translation: {
//       welcome: "Welcome",
//       greeting: "Hello, {{name}}!",
//       items: "{{count}} item",
//       items_plural: "{{count}} items",
//     },
//   },
//   es: {
//     translation: {
//       welcome: "Bienvenido",
//       greeting: "¡Hola {{name}}!",
//       items: "{{count}} artículo",
//       items_plural: "{{count}} artículos",
//     },
//   },
// };

const en = {
  navigation: {
    Aboutus: "About us",
    DeliveryandPayment: "Delivery and Payment",
    Specialoffers: "Special offers",
    FreeDeliveryover: "Free Delivery over",
  },
  categories: {
    Perfumes: "Perfumes",
    Makeup: "Makeup",
    Hair: "Hair",
    Face: "Face",
    BathandBody: "Bath & Body",
    ForMen: "For Men",
    Accessories: "Accessories",
    HealthandCare: "Health & Care",
    Gifts: "Gifts",
    Brands: "Brands",
    Aboutus: "About us",
    DeliveryandPayment: "Delivery and Payment",
    Specialoffers: "Special offers",
    FreeDeliveryover: "Free Delivery over",
    Perfumes: "Perfumes",
    Makeup: "Makeup",
    Hair: "Hair",
    Face: "Face",
    BathandBody: "Bath & Body",
    ForMen: "For Men",
    Accessories: "Accessories",
    HealthandCare: "Health & Care",
    Gifts: "Gifts",
    Brands: "Brands",
    //perfume
    WomenPerfumes: "Women's Perfumes",
    MenFragrances: "Men's Fragrances",
    UnisexPerfumes: "Unisex Perfumes",
    KidsPerfumes: "Kids' Perfumes",
    Sets: "Sets",
    NichePerfumes: "Niche Perfumes",
    ElitePerfumes: "Elite Perfumes",
    FrenchPerfumes: "French Perfumes",
    DubaiPerfumes: "Dubai Perfumes",
    Atomizers: "Atomizers",
    HomeFragrances: "Home Fragrances",
    New: "New",
    SALE: "SALE!",
    ScentedCandles: "Scented Candles",
    AromaLamps: "Aroma Lamps",
    Aromadiffusers: "Aromadiffusers",
    AromaSticks: "Aroma Sticks",
    AromaSprays: "Aroma Sprays",
    ShowallPerfumes: "Show all ...",
    //end perfume

    //makeup
    Brows: "Brows",
    Eyes: "Eyes",
    Lips: "Lips",
    Face: "Face",
    Brushes: "Brushes",
    MakeupRemovers: "Makeup Removers",
    Nails: "Nails",
    MakeupPalettes: "Makeup Palettes",
    PalettesandSets: "Palettes & Sets",
    Professional: "Professional",
    BrowPowders: "Brow Powders",
    BrowMascaras: "Brow Mascaras",
    BrowPencils: "Brow Pencils",
    BrowGels: "Brow Gels",
    BrowPomades: "Brow Pomades",
    LashandBrowColorsTints: "Lash & Brow Colors/Tints",
    Mascara: "Mascara",
    LashPrimers: "Lash Primers",
    EyePrimers: "Eye Primers",
    Eyeshadows: "Eyeshadows",
    EyelinerPencils: "Eyeliner Pencils",
    Eyeliners: "Eyeliners",
    EyeConcealers: "Eye Concealers",
    LashandBrowCare: "Lash & Brow Care",
    FalseEyelashes: "False Eyelashes",
    EyelashAdhesives: "Eyelash Adhesives",
    Lipsticks: "Lipsticks",
    LipGlosses: "Lip Glosses",
    LipLiners: "Lip Liners",
    LipTints: "Lip Tints",
    FacePrimers: "Face Primers",
    CCCreams: "CC-Creams",
    BBCreams: "BB-Creams",
    Blushes: "Blushes",
    Bronzers: "Bronzers",
    Highlighters: "Highlighters",
    IlluminatorsandShimmers: "Illuminators & Shimmers",
    Concealers: "Concealers",
    FacePowders: "Face Powders",
    Correctors: "Correctors",
    Foundations: "Foundations",
    NailPolishes: "Nail Polishes",
    GelPolishes: "Gel Polishes",
    NailPolishBaseCoats: "Nail Polish Base Coats",
    TopCoats: "Top Coats",
    NailDesign: "Nail Design",
    FakeNails: "Fake Nails",
    NailDryTopCoats: "Nail Dry Top Coats",
    NailPolishRemovers: "Nail Polish Removers",
    CuticleCare: "Cuticle Care",
    Treatment: "Treatment",
    ManicureandPedicureTools: "Manicure and Pedicure Tools",
    SpecialCareProducts: "Special Care Products",
    //end makeup

    //hair
    Shampoos: "Shampoos",
    HairRinses: "Hair Rinses",
    HairBalms: "Hair Balms",
    Conditioners: "Conditioners",
    HairMasks: "Hair Masks",
    ScalpExfoliation: "Scalp Exfoliation",
    ScalpScrubs: "Scalp Scrubs",
    HairAmpoules: "Hair Ampoules",
    HairLotions: "Hair Lotions",
    HairOils: "Hair Oils",
    HairSerumsandFluids: "Hair Serums & Fluids",
    HairCreams: "Hair Creams",
    Sprays: "Sprays",
    Keratin: "Keratin",
    HairColouring: "Hair Colouring",
    HairStyling: "Hair Styling",
    BlondeHair: "Blonde Hair",
    HairAccessories: "Hair Accessories",
    ForKids: "For Kids",
    HairProfessional: "Professional",
    DryShampoos: "Dry Shampoos",
    SulfateFreeShampoos: "SulfateFreeShampoos",
    AntiDandruffShampoos: "Anti-Dandruff Shampoos",
    SolidShampoos: "Solid Shampoos",
    CreamColours: "Cream Colours",
    Powders: "Powders",
    Oxidants: "Oxidants",
    Foam: "Foam",
    Gels: "Gels",
    Clays: "Clays",
    Jelly: "Jelly",
    Mousses: "Mousses",
    WaxandGlue: "Wax & Glue",
    Hairsprays: "Hairsprays",
    Pastes: "Pastes",
    PomadesandPowders: "Pomades & Powders",
    HairBrushes: "Hair Brushes",
    HairCurlers: "Hair Curlers",
    HairTiesandClips: "Hair Ties & Clips",
    HairDryersCurlingIronsHairStraighteners:
      "Hair Dryers, Curling Irons, Hair Straighteners",
    //end hair

    //face
    FaceCreams: "Face Creams",
    FaceMasks: "Face Masks",
    FaceBalms: "Face Balms",
    FaceFluids: "Face Fluids",
    SerumsElixirs: "Serums, Elixirs",
    FaceOils: "Face Oils",
    FaceCleansing: "Cleansing",
    AntiAging: "Anti-Aging",
    Toning: "Toning",
    Nourishing: "Nourishing",
    Moisturizing: "Moisturizing",
    SunProtection: "Sun Protection",
    EyeCare: "Eye Care",
    LipCare: "Lip Care",
    CleansingBrushes: "Cleansing Brushes",
    SpecialProducts: "Special Products",
    ShavingProductsforMen: "Shaving Products for Men",
    CleansingOils: "Cleansing Oils",
    FaceProfessional: "Professional",
    FaceConcentrates: "Face Concentrates",
    FaceSerums: "Face Serums",
    FaceEmulsions: "Face Emulsions",
    FaceMilk: "Face Milk",
    ScrubsPeelsExfoliators: "Scrubs, Peels, Exfoliators",
    FaceToners: "Face Toners",
    FaceFoams: "Face Foams",
    CleansingFaceGels: "Cleansing Face Gels",
    MicellarWater: "Micellar Water",
    CleansingOils: "Cleansing Oils",
    SunscreenCreams: "Sunscreen Creams",
    SelfTanners: "Self-Tanners",
    EyeBalms: "Eye Balms",
    EyePatches: "Eye Patches",
    EyeGels: "Eye Gels",
    EyeCreams: "Eye Creams",
    LashSerums: "Lash Serums",
    LipBalms: "Lip Balms",
    LipCreams: "Lip Creams",
    FaceSelfTanners: "Face Self-Tanners",
    //end face

    //BathAndBody
    BathandShower: "Bath & Shower",
    OralCare: "Oral Care",
    HairRemoval: "Hair Removal",
    DeodorantsAntiperspirants: "Deodorants, Antiperspirants",
    BodyCare: "Body Care",
    HandCare: "Hand Care",
    FootCare: "Foot Care",
    HygieneandCareProducts: "Hygiene and Care Products",
    CelluliteTreatment: "Cellulite Treatment",
    SunProtection: "Sun Protection",
    EssentialOils: "Essential Oils",
    HomeFragrances: "Home Fragrances",
    GelsLotionsShowerMilk: "Gels, Lotions, Shower Milk",
    Soap: "Soap",
    ScrubsExfoliators: "Scrubs & Exfoliators",
    IntimateHygiene: "Intimate Hygiene",
    BathSalt: "Bath Salt",
    BathFoam: "Bath Foam",
    BodyMud: "Body Mud",
    Toothbrushes: "Toothbrushes",
    InterdentalBrushes: "Interdental Brushes",
    DentalFloss: "Dental Floss",
    ToothpastesToothpowdersGels: "Toothpastes, Toothpowders, Gels",
    Mouthwashes: "Mouthwashes",
    Razors: "Razors",
    WaxStrips: "Wax Strips",
    CreamsLotionsBodyMilk: "Creams, Lotions, Body Milk",
    SerumsFluids: "Serums, Fluids",
    BodySpray: "Body Spray",
    BodyMasks: "Body Masks",
    NeckandDecollete: "Neck & Decollete",
    BustCare: "Bust Care",
    Deodorants: "Deodorants",
    Antiperspirants: "Antiperspirants",
    MassageOils: "Massage Oils",
    Cleansing: "Cleansing",
    StretchMarkTreatment: "Stretch Mark Treatment",
    CreamsandLotions: "Creams & Lotions",
    HandGels: "Hand Gels",
    MasksandScrubs: "Masks & Scrubs",
    HandParaffin: "Hand Paraffin",
    NailCare: "Nail Care",
    CreamsLotions: "Creams, Lotions",
    DeodorantsAntiperspirants: "Deodorants, Antiperspirants",
    MasksandScrubs: "Masks & Scrubs",
    SanitaryPads: "Sanitary Pads",
    Tampons: "Tampons",
    ProtectiveMask: "Protective Mask",
    Wipes: "Wipes",
    CottonBudsandPads: "Cotton Buds and Pads",
    ScentedCandles: "Scented Candles",
    AromaLamps: "Aroma Lamps",
    ReedDiffusers: "Reed Diffusers",
    ReedRefills: "Reed Refills",
    AromaSprays: "Aroma Sprays",
    //end BathAndBody

    //for men
    Perfumes: "Perfumes",
    Deodorants: "Deodorants",
    FaceandBodyCare: "Face and Body Care",
    ShavingProducts: "Shaving Products",
    HairCare: "Hair Care",
    ToolsandAccessories: "Tools and Accessories",
    Foot: "Foot",
    Hand: "Hand",
    Body: "Body",
    BeardCare: "BeardCare",
    Razors: "Razors",
    RazorBladeRefills: "Razor Blade Refills",
    ShavingFoam: "Shaving Foam",
    ShavingGels: "Shaving Gels",
    ShavingCreams: "Shaving Creams",
    CleansingandNutrition: "Cleansing and Nutrition",
    HairStyling: "Hair Styling",
    Trimmers: "Trimmers",
    HairClippers: "Hair Clippers",
    //end for men

    //accessories
    ForHair: "Hair",
    ForMakeup: "Makeup",
    HygieneandCare: "Hygiene & Care",
    BathandBody: "Bath & Body",
    Mirrors: "Mirrors",
    BagsMakeupBags: "Bags, Makeup Bags",
    Tweezers: "Tweezers",
    EyelashCurlers: "Eyelash Curlers",
    ManicureandPedicureTools: "Manicure & Pedicure Tools",
    HairRemoval: "Hair Removal",
    Massagers: "Massagers",
    HairBrushes: "Hair Brushes",
    HairTiesandClips: "Hair Ties & Clips",
    HairdressingSupplies: "Hairdressing Supplies",
    HairClippers: "Hair Clippers",
    HairDryersCurlingIronsHairStraighteners:
      "Hair Dryers, Curling Irons, Hair Straighteners",
    Brushes: "Brushes",
    SpongesandApplicators: "Sponges & Applicators",
    PencilSharpeners: "Pencil Sharpeners",
    CasesandBoxes: "Cases & Boxes",
    Wipes: "Wipes",
    CottonPadsandBuds: "Cotton Pads & Buds",
    FaceCleansingSponge: "Face Cleansing Sponge",
    BathSponges: "Bath Sponges",
    Towels: "Towels",
    ManicureTools: "Manicure Tools",
    PedicureTools: "Pedicure Tools",
    UVLEDNailLamps: "UV/LED Nail Lamps",
    NailClippers: "Nail Clippers",
    NailFilesandBuffers: "Nail Files & Buffers",
    FacialMassagers: "Facial Massagers",
    BodyMassagers: "Body Massagers",
    WomensBags: "Womens bags",
    womenswallet: "Womens wallet",
    Setbags: "Set bags",
    Womenswatches: "Womens watches",
    Menswallet: "Mens wallet",
    Labubu: "Labubu",
    Belt: "Belt",
    //end accessories

    //health and Care
    NaturalandOrganicCosmetics: "Natural & Organic Cosmetics",
    SexualWellnessProducts: "Sexual Wellness Products",
    PregnancyandMaternityProducts: "Pregnancy & Maternity Products",
    OralCare: "Oral Care",
    Optics: "Optics",
    NaturalCosmetics: "Natural Cosmetics",
    OrganicCosmetics: "Organic Cosmetics",
    Toothbrushes: "Toothbrushes",
    InterdentalBrushes: "Interdental Brushes",
    DentalFloss: "Dental Floss",
    ToothpastesToothpowdersandGels: "Toothpastes, Toothpowders & Gels",
    Mouthwash: "Mouthwash",
    Contactlenses: "Contact lenses",
    //end Health and Care

    //gifts
    GiftSets: "Gift Sets",
    GiftPackaging: "Gift Packaging",
    GiftCards: "Gift Cards",
    GiftsforWomen: "Gifts for Women",
    GiftsforMen: "Gifts for Men",
    Offers: "Offers",
    LEMAQBeautyClub: "Lemaq Beauty Club",
    //end gifts
  },
  profile: {
    ContactInfo: "Contact Info",
    AddressBook: "Address Book",
    Orderhistory: "Order history",
    Wishlist: "Wishlist",
    Promocodes: "Promo codes",
    Logoff: "Log off",
    Save: "Save",
    Bethefirsttoknowaboutsalesandnewarrivals:
      "Be the first to know about sales and new arrivals",
    Contactus: "Contact us",
    Termsofuse: "Terms of use",
    Privacy: "Privacy",
    Shipping: "Shipping",
    Aboutourproducts: "About our products",
    ReturnsandExchanges: "Returns & Exchanges",
    Articles: "Articles",
    News: "News",
    Trackprice: "Track price",
    Checkout: "Checkout",
    Gotopay: "Checkout",
    Orderprice: "Order price",
    Totalamount: "Total amount",
    Cart: "Cart",
    Yourorders: "Your orders",
    Next: "Next",
    Subtotal: "Subtotal",
    Shipping: "Shipping (To Your Home)",
    GrandTotal: "Grand Total",
    Buy: "Buy",
    Callback: "Call back",
    Specialoffers: "Special offers",
    Specialoffersfilter: "Special offers filter",
    Filters: "Filters",
    All: "All",
    AllCat: "All",
    Login: "Log in",
    Registration: "Registration",
    Newuserregistration: "New user registration",
    Recievenotificationsaboutnewarrivalssalesspecialoffers:
      "Recieve notifications about new arrivals, sales, special offers",
    subscribe: "SUBSCRIBE",
    Forgotyourpassword: "Forgot your password?",
    morethan100000products: "More than 100 000 products",
    Passwordrecovery: "Password recovery",
    Send: "Send",
    Specialofferwillendin: "Special offer will end in",
    days: "days",
    and: "and",
    Addanewaddress: "Add a new address",
    Searchresults: "Search results",
    Personalinfo: "Personal info",
    Deliverydetails: "Delivery details",
    Deliveryaddress: "Delivery address",
    Recommended: "Recommended",
    products: "products",
    Addacommenttotheorder: "Add a comment to the order",
    Ihaveapromocodeorcertificate: "I have a promo code or certificate",
    Countinueshopping: "Countinue shopping",
    Firstandlastname: "First and last name",
    email: "E-mail",
    Password: "Password",
    NewPassword: "New password",
    Repeatpassword: "Repeat password",
    Oldpassword: "Old password",
    Confirmpassword: "Confirm password",
    Phone: "Phone number",
    Countrynumber: "Country number",
    City: "City",
    Street: "Street",
    Pleaseloginfirsttopurchasethisproduct:
      "Please log in first to purchase this product.",
    Ok: "Ok",
    Messagetext: "Message text",
    Fullname: "Full name",
    Firstname: "First name",
    Lastname: "Last name",
    Dateofbirth: "Date of birth",
    Sortby: "Sort by",
    Sort: "Sort",

    LeaveyourcommentAskaaquestion: "Leave your comment/ Ask a aquestion",
    Yourrating: "Your rating",
    Youcanleavearevieworaskaquestion:
      "You can leave a review or ask a question",
    Pleaseloginfirsttopurchasethisproduct:
      "Please login first to purchase this product.",
    Changeaddress: "Add or change address",
    edit: "edit",
    WEWILLCALLYOUBACK: "WE WILL CALL YOU BACK!",
    WEAREALWAYSINTOUCH: "WE ARE ALWAYS IN TOUCH!",
    Done: "Done",
    DoneLang: "Done",

    SpecialOffersfrom: "Special Offers from",
    name: "name",
    price: "price",
    popularity: "popularity",
    lowtohigh: "low to high",
    hightolow: "high to low",
    Changecontactinfo: "Change contact info",
    AllResults: "All results",
    ClearAll: "Clear All",
    Clear: "Clear",
    Apply: "Apply",
    Subject: "Subject",
    chooseadepartment: "choose a department",
    partnership: "partnership",
    markiting: "markiting",
    customerservice: "customer service",
    successfullysent: "successfully sent!",
    OurStory: "Our Story",
    OurMissionValues: "Our Mission & Values",
    WhyChooseUs: "Why Choose Us?",
    ThankYou: "Thank You!",
    SunFri: "Sun - Fri: 9:00 AM to 21:00 PM",
    Reviewson: "Reviews on",
    Reviews: "Reviews",
    Recentlyviewed: "Recently viewed",
    Less: "Less",
    Morethan: "More than",
    From: "From",
    To: "To",
    ZIPCode: "ZIP Code",
    Apt: "# Apt",
    Building: "Building",
    Enterpromocode: "Enter promo code",
    Usepromocode: "Use promo code",
    CreditorDebitCardNumber: "Credit or Debit Card Number",
    ExpiryDate: "Expiry Date",
    Nameoncard: "Name on card*",
    MMYY: "Month and Year",
    Fullnameasoncard: "Full name as on card",
    PAY: "PAY",
    Noordersfound: "No orders found",
    Doyouwantpaycashorcreditcard: "Do you want pay cash or credit card ?",
    pleasechoosepaymentmethod: "Please choose payment method",
    Freedeleviryover: "Free deleviry over ₪199!",
    InStock: "In Stock",
    Outofstock: "Out of stock",
    productID: "product ID:",
    SimilarProducts: "Similar Products",
    Cash: "Cash",
    CreditCard: "Credit card",
    paywhenreceivetheorder: "pay when receive the order",
    Greatwewillcontactyouassoonaspossible:
      "Great, we will contact you as soon as possible",
    Chooselanguage: "Choose language",
    Pleasecreateaddress: "Please create address",
    Emptylist: "Empty list",
    Favorites: "Favorites",
    Menu: "Menu",
    thedealsuccessfullydone: "the deal successfully done",
    Pleasefillinallrequiredfields: "Please fill in all required fields.",
    UseCode: "Use Code",
    OFF: "OFF",
    Used: "Used",
    Active: "Active",
    Getflat: " Get flat",
    offonyourpurchase: "off on your purchase. Hurry, offer ends after!",
    CopyCode: "Copy Code",
    Copied: "Copied",
    Orloginwith: "Or login with",
    Subscribe: "SUBSCRIBE",
    Yes: "Yes",
    No: "No",
    Characteristics: "Characteristics",
    Description: "Description",
    areyousureyouwantcancelsubscription:
      "are you sure you want cancel subscription ?",
    AreyousureyouwanttodeletethisAddress:
      "Are you sure you want to delete this Address ?",
    Beautyclubdiscount: "Beauty club discount",
    Pleaseaddthedeliveryaddresstocompletetheorder:
      "Please add the delivery address to complete the order",
    Youdonothaveadeliveryaddress: "You do not have a delivery address.",
    Pleaseaddadeliveryaddress: "Please add a delivery address.",

    Deliverywithindays: "Delivery within 1-7 days",
    original: "ORIGINAL",
    master: "MASTER",
  },
  profileOrderHistory: {
    Orderdetails: "Order details",
    Orderid: "Order id",
    Totalprice: "Total price",
    Dateorder: "Date order",
    Timeorder: "Time order",
    Fullname: "Full name",
    Phonenumber: "Phonenumber",
    city: "city",
    Street: "Street",
    Building: "Building",
    Apartment: "Apartment",
    ZIPcode: "ZIP code",

    comment: "Comment",
    Addressdetails: "Address details",
    couponcode: "Coupon code",
    Codeused: "Code used",
    Discount: "Discount",
    ordered: "Ordered",
    withdeliveryman: "with delivery man",
    delivered: "Delivered",
    Pricebeforediscounts: "Price before discounts",
    PricebeforePromocodeDiscount: "Price before Promo code Discount",
    Discountcouponcode: "Discount coupon code",
    delivery: "Delivery",
    GrandTotal: "Grand Total",
    yousaved: "you saved",
    Price: "Price",
    Free: "Free",
    paymenttype: "Payment type",
    Place: "Arara - Second Main Entrance (Al-Batin Street)",
  },

  sentence: {
    Youcan: "You can",
    emailus: "e-mail us",
    callus: "call us",
    Contacts: "CONTACTS",
  },
  filters: {
    Brand: "Brand",
    ProductType: "Product Type",
    Classification: "Classification",
    ProductProperties: "Product Properties",
    Gender: "Gender",
    ScentType: "Scent Type",
    TopNote: "Top Note",
    HeartNote: "Heart Note",
    BaseNote: "Base Note",
    Ingredients: "Ingredients",
    SpecialCertificates: "Special Certificates",
    Volume: "Volume",
    MadeIn: "Made In",
    Color: "Color",
    ProtectionLevel: "Protection Level",
    EyeshadowEffect: "Eyeshadow Effect",
    Formula: "Formula",
    Country: "Country",
    HairType: "Hair Type",
    BrushMaterial: "Brush Material",
    SkinType: "Skin Type",
    Age: "Age",
    PriceRanges: "Price Ranges",
  },
  longTexts: {
    InCheckOutForPromoCode:
      "Enter the certificate code or special promo code in this field to receive a discount or a gift.",
    acceptTerms: "Yes, I accept Terms of Use and Privacy Policy Lemaq.",

    Youcanalways:
      "You can always contact us by phone number indicated in the header of the site. You can also send your request/complaint/suggestion using the following form.",

    OurStoryDisc:
      "Welcome to Lemaq! We started with a simple passion: to bring high-quality, cruelty-free, and affordable makeup to beauty lovers everywhere. Founded in 2024, our journey began when Mohammed shekh abed noticed a gap in the market for specific niche, e.g., vegan makeup, inclusive shades, sustainable beauty. Today, we’re proud to offer products that empower you to express yourself—without compromise.",

    Thankyouforsupporting:
      "Thank you for supporting our dream. We’re thrilled to be part of your beauty journey!",

    QualityFirst:
      "Quality First: We rigorously test every product to ensure it meets our high standards.",
    CrueltyFree: "Cruelty-Free & Vegan: No animals harmed—ever.",
    Inclusivity:
      "Inclusivity: Makeup for all skin tones, types, and identities.",
    Sustainability:
      "Sustainability: Eco-friendly packaging & ethically sourced ingredients.",
    AffordableLuxury:
      "✨ Affordable Luxury: Premium quality without the hefty price tag.",
    TrendDrivenTimeless:
      "💄 Trend-Driven & Timeless: From everyday essentials to bold trends.",
    FastReliableShipping:
      "🚚 Fast & Reliable Shipping: Because waiting for beauty goodies is hard!",
  },
  delivery: {
    Youwill: "You will receive your parcel to your home with Lemaq Delivery.",
    Thedelivery:
      "The delivery is free for orders over ₪199. For orders under ₪199 the delivery cost is ₪19.90",
    Yourparcelwillbedeliveredonaveragewithin:
      "Your parcel will be delivered on average within",
    workingdays: "1-7 working days ",
    fromthedate:
      "from the date of your order excluding weekends and public holidays.",
    Deliveryiscarried:
      "Delivery is carried out after we receive your order and payment online. You can pay for your order using VISA/Mastercard, during checkout.",
    Aftertheorder:
      "After the order is placed, our customer service will process it. Once the parcel is packed it will be transferred to delivery team.",
    Youwillreceive:
      "You will receive e-mail notifications with the order status updates and the parcel tracking number.",
  },

  BeautyClub: {
    Welcometo: "Welcome to",
    wherebeautymeetssmartshopping: "where beauty meets smart shopping.",
    Nowyoucanunlock:
      "Now, you can unlock exclusive savings and premium perks by joining our Beauty Club – a monthly",
    subscriptiondesignedformakeup:
      "subscription designed for makeup lovers like you.",
    WhyJointhe: "Why Join the",

    OFFeverysingle: "OFF every single order – no limits",
    The: "The",
    OFFalsocomebeside:
      "OFF also come beside offers! like there is offer 20% OFF, you will get 30% OFF!",
    Monthlysurprises:
      "Monthly surprises – deluxe samples or early access to new arrivals",
    Freeexpressshipping:
      "Free express shipping on orders over ₪199 (Beauty Club exclusive)",
    Membersonlydeals: "Members-only deals, sales, and bundles",
    Cancelanytimenolongtermcommitments:
      "Cancel anytime – no long-term commitments",
    RealExample: "Real Example",
    MatteLipstick: "Matte Lipstick – ₪100",
    Nonmember: "Non-member: ₪100",
    BeautyClubMember: "Beauty Club Member: ₪90 ✅",
    SkincareSet: "Skincare Set – ₪250",
    Nonmember250: "Non-member: ₪250",
    BeautyClubMember225: "Beauty Club Member: ₪225 ✅",
    Justtwoitemscan: "Just two items can",
    saveyou35: "save you ₪35+",
    inoneorderalone: "in one order alone.",
    FrequentlyAskedQuestions: "Frequently Asked Questions",
    WhathappensafterIsubscribe: "Q: What happens after I subscribe?",
    Youllinstantlyunlockyour: "You’ll instantly unlock your",
    discountandperks:
      "discount and perks. Your subscription is tied to your LemaqStore account.",
    CanIcancelanytime: "Q: Can I cancel anytime?",
    YesYoucancancelyour:
      "Yes! You can cancel your subscription anytime from your profile. No questions asked.",
    Whatpaymentmethodsdoyousupport: "Q: What payment methods do you support?",
    Weacceptallmajor:
      "We accept all major credit cards. Payment is billed monthly.",
    DoIneedtocommitforawholeyear: "Q: Do I need to commit for a whole year?",
    NopeItsmonthlyStartorstopwheneveryoulike:
      "Nope. It’s monthly. Start or stop whenever you like.",
    ReadytoSaveonEveryOrder: "Ready to Save on Every Order?",
    Jointhousandsofhappy:
      "Join thousands of happy LemaqStore customers who now shop smarter.",
    JoinBeautyClubStartSaving: "[Join Beauty Club – Start Saving]",
    OnlymonthCancelAnytimeOffEverything:
      "Only ₪49/month · Cancel Anytime · 10% Off Everything",
    SUBSCRIBENOW: "SUBSCRIBE NOW!",
    Pleaseloginfirst: "Please login first",
    CANCELSUBSCRIBE: "CANCEL SUBSCRIBE",
  },
};
const ar = {
  navigation: {
    Aboutus: "معلومات عنا",
    DeliveryandPayment: "التسليم والدفع",
    Specialoffers: "عروض خاصة",
    FreeDeliveryover: "توصيل مجاني للطلبات التي تزيد عن",
  },
  categories: {
    Perfumes: "عطور",
    Makeup: "مكياج",
    Hair: "شعر",
    Face: "وجه",
    BathandBody: "الاستحمام والجسم",
    ForMen: "للرجال",
    Accessories: "اكسسوارات",
    HealthandCare: "الصحة والرعاية",
    Gifts: "الهدايا",
    Brands: "العلامات التجارية",
    Aboutus: "معلومات عنا",
    DeliveryandPayment: "التسليم والدفع",
    Specialoffers: "عروض خاصة",
    FreeDeliveryover: "توصيل مجاني للطلبات التي تزيد عن",
    Perfumes: "عطور",
    Makeup: "مكياج",
    Hair: "شعر",
    Face: "وجه",
    BathandBody: "الاستحمام والجسم",
    ForMen: "للرجال",
    Accessories: "اكسسوارات",
    HealthandCare: "الصحة والرعاية",
    Gifts: "الهدايا",
    Brands: "العلامات التجارية",

    //perfume
    WomenPerfumes: "عطور للنساء",
    MenFragrances: "عطور للرجال",
    UnisexPerfumes: "عطور للجنسين",
    KidsPerfumes: "عطور للاطفال",
    Sets: "مجموعات",
    NichePerfumes: "عطور نيش",
    ElitePerfumes: "عطور النخبة",
    FrenchPerfumes: "عطور فرنسية",
    DubaiPerfumes: "عطور دبي",
    Atomizers: "البخاخات",
    HomeFragrances: "عطور منزلية",
    New: "جديد",
    SALE: "تخفيض!",
    ScentedCandles: "الشموع المعطرة",
    AromaLamps: "مصابيح الروائح",
    Aromadiffusers: "معطرات الجو",
    AromaSticks: "أعواد العطر",
    AromaSprays: "بخاخات العطور",
    ShowallPerfumes: "عرض الكل ...",

    //end perfume

    //makeup
    Brows: "حواجب",
    Eyes: "عيون",
    Lips: "شفاه",
    Face: "وجه",
    Brushes: "فراشي",
    MakeupRemovers: "مزيلات المكياج",
    Nails: "اظافر",
    MakeupPalettes: "لوحات المكياج",
    PalettesandSets: "لوحات ومجموعات",
    Professional: "مكياج احترافي",
    BrowPowders: "بودرة الحواجب",
    BrowMascaras: "ماسكارا الحواجب",
    BrowPencils: "أقلام الحواجب",
    BrowGels: "جل الحواجب",
    BrowPomades: "مراهم الحواجب",
    LashandBrowColorsTints: "ألوان/صبغات الرموش والحواجب",
    Mascara: "ماسكارا",
    LashPrimers: "برايمر الرموش",
    EyePrimers: "برايمرات العيون",
    Eyeshadows: "ظلال العيون",
    EyelinerPencils: "أقلام تحديد العيون",
    Eyeliners: "محدد العيون",
    EyeConcealers: "خافي عيوب العيون",
    LashandBrowCare: "العناية بالرموش والحواجب",
    FalseEyelashes: "رموش صناعية",
    EyelashAdhesives: "لاصقات الرموش",
    Lipsticks: "أحمر شفاه",
    LipGlosses: "ملمع الشفاه",
    LipLiners: "أقلام تحديد الشفاه",
    LipTints: "صبغات الشفاه",
    FacePrimers: "برايمرات الوجه",
    CCCreams: "كريمات CC",
    BBCreams: "كريمات BB",
    Blushes: "احمرار الخدود",
    Bronzers: "البرونزر",
    Highlighters: "أقلام التمييز",
    IlluminatorsandShimmers: "المضيئات واللمعات",
    Concealers: "كونسيلر",
    FacePowders: "بودرة الوجه",
    Correctors: "كوريكتورس",
    Foundations: "فاونديشن",
    NailPolishes: "طلاء الأظافر",
    GelPolishes: "طلاء الجل",
    NailPolishBaseCoats: "طبقات أساسية لطلاء الأظافر",
    TopCoats: "مقوي الأظافر",
    NailDesign: "تصميم الأظافر",
    FakeNails: "أظافر صناعية",
    NailDryTopCoats: "تجفيف طلاء الأظافر",
    NailPolishRemovers: "مزيلات طلاء الأظافر",
    CuticleCare: "العناية بالبشرة",
    Treatment: "علاج",
    ManicureandPedicureTools: "أدوات مانيكير وباديكير",
    SpecialCareProducts: "منتجات العناية الخاصة",
    //end makeup

    //hair
    Shampoos: "شامبو",
    HairRinses: "شطف الشعر",
    HairBalms: "بلسم الشعر",
    Conditioners: "مكيفات الشعر",
    HairMasks: "أقنعة الشعر",
    ScalpExfoliation: "تقشير فروة الرأس",
    ScalpScrubs: "مقشرات فروة الرأس",
    HairAmpoules: "أمبولات الشعر",
    HairLotions: "لوشن الشعر",
    HairOils: "زيوت الشعر",
    HairSerumsandFluids: "سيرومات وسوائل الشعر",
    HairCreams: "كريمات الشعر",
    Sprays: "بخاخات",
    Keratin: "كيراتين",
    HairColouring: "تلوين الشعر",
    HairStyling: "تصفيف الشعر",
    BlondeHair: "شعر أشقر",
    HairAccessories: "إكسسوارات الشعر",
    ForKids: "للأطفال",
    HairProfessional: "العناية بالشعر بشكل احترافي",
    DryShampoos: "شامبو جاف",
    SulfateFreeShampoos: "شامبو خالٍ من الكبريتات",
    AntiDandruffShampoos: "شامبوهات مضادة للقشرة",
    SolidShampoos: "شامبو صلب",
    CreamColours: "ألوان الشعر",
    Powders: "بودرة الشعر",
    Oxidants: "المؤكسدات",
    Foam: "رغوة شعر",
    Gels: "جل الشعر",
    Clays: "طين الشعر",
    Jelly: "جل الشعر",
    Mousses: "موس الشعر",
    WaxandGlue: "غراء الشعر والشمع",
    Hairsprays: "بخاخات الشعر",
    Pastes: "المعاجين",
    PomadesandPowders: "المراهم والبودرة",
    HairBrushes: "الفرش والأمشاط",
    HairCurlers: "مكواة تجعيد الشعر",
    HairTiesandClips: "ربطات ومشابك الشعر",
    HairDryersCurlingIronsHairStraighteners:
      "مجففات الشعر، مكواة تجعيد الشعر، مكواة فرد الشعر",
    //end hair

    //face
    FaceCreams: "كريمات الوجه",
    FaceMasks: "أقنعة الوجه",
    FaceBalms: "بلسم الوجه",
    FaceFluids: "سوائل الوجه",
    SerumsElixirs: "مصل الوجه",
    FaceOils: "زيوت الوجه",
    FaceCleansing: "تنظيف الوجه",
    AntiAging: "مضاد للشيخوخة",
    Toning: "منتجات منعشة",
    Nourishing: "مغذي",
    Moisturizing: "مرطب",
    SunProtection: "الحماية من الشمس",
    EyeCare: "العناية بالعيون",
    LipCare: "العناية بالشفاه",
    CleansingBrushes: "اسفنجات تنظيف الوجه",
    SpecialProducts: "منتجات خاصة",
    ShavingProductsforMen: "منتجات الحلاقة للرجال",
    CleansingOils: "زيوت التنظيف",
    FaceProfessional: "الرعاية المهنية",
    FaceConcentrates: "مركزات الوجه",
    FaceSerums: "سيرومات الوجه",
    FaceEmulsions: "مستحلبات الوجه",
    FaceMilk: "حليب تنظيف الوجه",
    ScrubsPeelsExfoliators: "فرك وتقشير",
    FaceToners: "تونر الوجه",
    FaceFoams: "رغوة الوجه",
    CleansingFaceGels: "جل تنظيف الوجه",
    MicellarWater: "ماء ميسيلار",
    CleansingOils: "زيوت التنظيف",
    SunscreenCreams: "كريمات الوقاية من الشمس",
    SelfTanners: "مستحضرات تسمير البشرة الذاتية",
    EyeBalms: "بلسم العين",
    EyePatches: "رقعة العين",
    EyeGels: "جل العيون",
    EyeCreams: "كريمات العيون",
    LashSerums: "سيروم الرموش",
    LipBalms: "مرطبات الشفاه",
    LipCreams: "كريمات الشفاه",
    FaceSelfTanners: "تسمير الوجه ذاتيًا",
    //end face

    //BathAndBody
    BathandShower: "الاستحمام وتنظيف الجسم",
    OralCare: "العناية بالفم",
    HairRemoval: "إزالة الشعر",
    DeodorantsAntiperspirants: "مزيلات العرق ومضادات التعرق",
    BodyCare: "العناية بالجسم",
    HandCare: "العناية باليدين",
    FootCare: "العناية بالقدم",
    HygieneandCareProducts: "منتجات النظافة والعناية",
    CelluliteTreatment: "علاج السيلوليت",
    SunProtection: "الحماية من الشمس",
    EssentialOils: "الزيوت العطرية",
    HomeFragrances: "عطور منزلية",
    GelsLotionsShowerMilk: "المواد الهلامية والغسولات والمستحضرات",
    Soap: "صابون",
    ScrubsExfoliators: "فرك وتقشير",
    IntimateHygiene: "غسولات النظافة النسائية",
    BathSalt: "ملح الاستحمام",
    BathFoam: "رغوة الاستحمام",
    BodyMud: "طين الجسم",
    Toothbrushes: "فرشاة الأسنان",
    InterdentalBrushes: "فرشاة بين الأسنان",
    DentalFloss: "خيط تنظيف الأسنان",
    ToothpastesToothpowdersGels:
      "معاجين الأسنان، مساحيق الأسنان، المواد الهلامية",
    Mouthwashes: "غسولات الفم",
    Razors: "شفرات الحلاقة",
    WaxStrips: "شرائح الشمع",
    CreamsLotionsBodyMilk: "الكريمات والمستحضرات",
    SerumsFluids: "الأمصال والسوائل",
    BodySpray: "رذاذ الجسم",
    BodyMasks: "أقنعة الجسم",
    NeckandDecollete: "للرقبة ومنطقة الصدر",
    BustCare: "العناية بالصدر",
    Deodorants: "مزيلات العرق",
    Antiperspirants: "مضادات التعرق",
    MassageOils: "زيوت التدليك",
    Cleansing: "تنظيف الجسم",
    StretchMarkTreatment: "علاج علامات التمدد",
    CreamsandLotions: "الكريمات والمستحضرات",
    HandGels: "معقمات اليدين",
    MasksandScrubs: "الأقنعة والمقشرات",
    HandParaffin: "بارافين اليد",
    NailCare: "العناية بالأظافر",
    CreamsLotions: "الكريمات والمستحضرات",
    DeodorantsAntiperspirants: "مزيلات العرق ومضادات التعرق",
    MasksandScrubs: "الأقنعة والمقشرات",
    SanitaryPads: "الفوط الصحية",
    Tampons: "السدادات القطنية",
    ProtectiveMask: "قناع واقٍ",
    Wipes: "مناديل",
    CottonBudsandPads: "أعواد القطن والوسادات",
    ScentedCandles: "الشموع المعطرة",
    AromaLamps: "مصابيح الروائح",
    ReedDiffusers: "موزعات العطور",
    ReedRefills: "أعواد معطرة",
    AromaSprays: "بخاخات العطور",
    //end BathAndBody

    //for men
    Perfumes: "عطور",
    Deodorants: "مزيلات العرق",
    FaceandBodyCare: "العناية بالوجه والجسم",
    ShavingProducts: "منتجات الحلاقة",
    HairCare: "العناية بالشعر",
    ToolsandAccessories: "الأدوات والملحقات",
    Foot: "قدم",
    Hand: "يد",
    Body: "جسم",
    BeardCare: "العناية باللحية",
    Razors: "شفرات الحلاقة",
    RazorBladeRefills: "عبوات شفرات الحلاقة",
    ShavingFoam: "رغوة الحلاقة",
    ShavingGels: "جل الحلاقة",
    ShavingCreams: "كريمات الحلاقة",
    CleansingandNutrition: "التنظيف والتغذية",
    HairStyling: "التصميم",
    Trimmers: "المقلمات",
    HairClippers: "ماكينة قص الشعر",
    //end for men

    //accessories
    ForHair: "للشعر",
    ForMakeup: "للمكياج",
    HygieneandCare: "النظافة والعناية",
    BathandBody: "الاستحمام وتنظف الجسم",
    Mirrors: "مرايا",
    BagsMakeupBags: "حقائب، حقائب مكياج",
    Tweezers: "ملاقيط",
    EyelashCurlers: "مكبس الرموش",
    ManicureandPedicureTools: "أدوات مانيكير وباديكير",
    HairRemoval: "إزالة الشعر",
    Massagers: "أجهزة التدليك",
    HairBrushes: "فرش الشعر",
    HairTiesandClips: "ربطات ومشابك الشعر",
    HairdressingSupplies: "مستلزمات تصفيف الشعر",
    HairClippers: "ماكينة قص الشعر",
    HairDryersCurlingIronsHairStraighteners:
      "مجففات الشعر، مكواة تجعيد الشعر، مكواة فرد الشعر",
    Brushes: "فرش المكياج",
    SpongesandApplicators: "اسفنجات المكياج",
    PencilSharpeners: "مبراة ألاقلام",
    CasesandBoxes: "الحافظات",
    Wipes: "مناديل",
    CottonPadsandBuds: "وسادات قطنية ومسحات",
    FaceCleansingSponge: "اسفنجة تنظيف الوجه",
    BathSponges: "اسفنجات الاستحمام",
    Towels: "المناشف",
    ManicureTools: "أدوات مانيكير",
    PedicureTools: "أدوات باديكير",
    UVLEDNailLamps: "مصابيح UV/LED",
    NailClippers: "مقص أظافر",
    NailFilesandBuffers: "مبردات الأظافر",
    FacialMassagers: "أجهزة تدليك الوجه",
    BodyMassagers: "أجهزة تدليك الجسم",
    WomensBags: "حقائب نسائية",
    womenswallet: "جزادين ستاتي",
    Setbags: "شنط اطقم",
    Womenswatches: "ساعات نسائية",
    Menswallet: "محفظة رجالية",
    Labubu: "لابوبو",
    Belt: "قشاط - سبك",

    //end accessories

    //health and Care
    NaturalandOrganicCosmetics: "مستحضرات التجميل الطبيعية والعضوية",
    SexualWellnessProducts: "منتجات الصحة الجنسية",
    PregnancyandMaternityProducts: "منتجات الحمل والأمومة",
    OralCare: "العناية بالفم",
    Optics: "بصريات",
    NaturalCosmetics: "مستحضرات التجميل الطبيعية",
    OrganicCosmetics: "مستحضرات التجميل العضوية",
    Toothbrushes: "فرشاة الأسنان",
    InterdentalBrushes: "فرشاة بين الأسنان",
    DentalFloss: "خيط تنظيف الأسنان",
    ToothpastesToothpowdersandGels:
      "معاجين الأسنان ومساحيق الأسنان والمواد الهلامية",
    Mouthwash: "غسول الفم",
    Contactlenses: "العدسات اللاصقة",
    //end Health and Care

    //gifts
    GiftSets: "مجموعات الهدايا",
    GiftPackaging: "تغليف الهدايا",
    GiftCards: "بطاقات الهدايا",
    GiftsforWomen: "هدايا للنساء",
    GiftsforMen: "هدايا للرجال",
    Offers: "عروض",
    LEMAQBeautyClub: "Lemaq Beauty Club",

    //end gifts
  },
  profile: {
    ContactInfo: "المعلومات",
    AddressBook: "دفتر العناوين",
    Orderhistory: "سجل الطلبات",
    Wishlist: "قائمة الرغبات",
    Promocodes: "كوبونات",
    Logoff: "الخروج",
    Save: "حفظ",
    Bethefirsttoknowaboutsalesandnewarrivals:
      "كن أول من يعرف عن المنتجات الجديدة",
    Contactus: "تواصل معنى",
    Termsofuse: "شروط الاستخدام",
    Privacy: "خصوصية",
    Shipping: "شحن",
    Aboutourproducts: "حول منتجاتنا",
    ReturnsandExchanges: "الإرجاع والاستبدال",
    Articles: "المقالات",
    News: "عروض خاصة",
    Trackprice: "تتبع السعر",
    Checkout: "الدفع",
    Gotopay: "الذهاب للطلب",

    Orderprice: "سعر الطلب",
    Totalamount: "المبلغ الإجمالي",
    Cart: "عربة التسوق",
    Yourorders: "طلباتك",
    Next: "التالي",
    Subtotal: "المجموع",
    Shipping: "الشحن (إلى منزلك)",
    GrandTotal: "المجموع الإجمالي",
    Buy: "شراء",
    Callback: "لنتصل بك",
    Specialoffers: "عروض خاصة",
    Specialoffersfilter: "فلتر العروض الخاصة",
    Filters: "فلاتر",
    All: "الكل",
    AllCat: "كل ال",

    Login: "تسجيل الدخول",
    Registration: "تسجيل",
    Newuserregistration: "تسجيل مستخدم جديد",
    Recievenotificationsaboutnewarrivalssalesspecialoffers:
      "تلقي إشعارات حول المنتجات الجديدة والمبيعات والعروض الخاصة",
    subscribe: "متابعة",
    Forgotyourpassword: "نسيت كلمة السر؟",
    morethan100000products: "أكثر من 100,000 منتج",
    Passwordrecovery: "استعادة كلمة المرور",
    Send: "ارسل",
    Specialofferwillendin: "العرض الخاص سينتهي خلال",
    days: "يوم",
    and: "و",
    Addanewaddress: "إضافة عنوان جديد",
    Searchresults: "نتائج البحث",
    Personalinfo: "المعلومات الشخصية",
    Deliverydetails: "تفاصيل التسليم",
    Deliveryaddress: "عنوان التسليم",
    Recommended: "موصى بها",
    products: "منتجات",
    Addacommenttotheorder: "أضف تعليقًا على الطلب",
    Ihaveapromocodeorcertificate: "لدي قسيمة شراء",
    Countinueshopping: "متابعة التسوق",
    Firstandlastname: "الاسم واسم العائلة",
    email: "البريد الالكتروني",
    Password: "كلمة السر",
    NewPassword: "كلمة سر الجديدة",
    Repeatpassword: "كرر كلمة السر",
    Oldpassword: "كلمة المرور القديمة",
    Confirmpassword: "تأكيد كلمة المرور",
    Countrynumber: "رقم الدولة",

    Phone: "رقم الهاتف",
    City: "المدينة",
    Street: "الشارع",
    Pleaseloginfirsttopurchasethisproduct:
      "يرجى تسجيل الدخول أولاً لشراء هذا المنتج.",
    Ok: "حسنا",
    Fullname: "الاسم الكامل",
    Messagetext: "نص الرسالة",

    Firstname: "الاسم",
    Lastname: "اسم العائلة",
    Dateofbirth: "تاريخ الميلاد",
    Sortby: "فرز حسب",
    Sort: "فرز",

    LeaveyourcommentAskaaquestion: "اترك تعليقك/ اسال سؤالا",
    Yourrating: "تقييمك",
    Youcanleavearevieworaskaquestion: "يمكنك ترك تعليق أو طرح سؤال",
    Pleaseloginfirsttopurchasethisproduct:
      ".يرجى تسجيل الدخول أولاً لشراء هذا المنتج",
    edit: "تعديل",
    WEWILLCALLYOUBACK: "!سوف نتصل بك",
    WEAREALWAYSINTOUCH: "نحن دائمًا على اتصال !",
    Done: "تم",
    DoneLang: "تم",

    SpecialOffersfrom: "عروض خاصة من",
    name: "الاسم",
    price: "السعر",
    popularity: "شعبية",
    lowtohigh: "ترتيب تصاعدي",
    hightolow: "ترتيب تنازلي",
    Changeaddress: "اضافة او تغيير العنوان",
    Changecontactinfo: "تغيير معلومات الاتصال",
    AllResults: "جميع النتائج",
    ClearAll: "مسح الكل",
    Clear: "مسح",
    Apply: "تم",

    Subject: "موضوع",
    chooseadepartment: "اختر القسم",
    partnership: "شراكة",
    markiting: "تسويق",
    customerservice: "خدمة العملاء",
    successfullysent: "تم الإرسال بنجاح!",
    OurStory: "قصتنا",
    OurMissionValues: "مهمتنى وقيمنا",
    WhyChooseUs: "لماذا تختارنا؟",
    ThankYou: "شكرًا لك!",
    SunFri: "الأحد - الجمعة: 9:00 صباحًا إلى 21:00 مساءً",
    Reviewson: "المراجعات على",
    Reviews: "المراجعات",

    Recentlyviewed: "تمت مشاهدته مؤخرًا",
    Less: "أقل من",
    Morethan: "أكثر من",
    From: "من",
    To: "الى",
    ZIPCode: "الرمز البريدي",
    Apt: "شقة",
    Building: "مبنى",
    Enterpromocode: "ادخل كود الكوبون",
    Usepromocode: "استعمل كود الكوبون",
    CreditorDebitCardNumber: "رقم البطاقة الائتمانية*",
    ExpiryDate: "تاريخ انتهاء الصلاحية*",
    Nameoncard: "الاسم الموجود على البطاقة*",
    MMYY: "الشهر والسنة",
    Fullnameasoncard: "الاسم الكامل كما هو موجود على البطاقة",
    PAY: "دفع",
    Noordersfound: "لم يتم العثور على أي طلبات",
    Doyouwantpaycashorcreditcard: "هل تريد الدفع نقدا أو ببطاقة الائتمان؟",
    pleasechoosepaymentmethod: "الرجاء اختيار طريقة الدفع",
    Freedeleviryover: "شحن مجاني عند شراء أكثر من ₪199!",
    InStock: "متوفر",
    Outofstock: "غير متوفر",
    productID: "معرف المنتج:",
    SimilarProducts: "منتجات مماثلة",
    Cash: "نقدا",
    CreditCard: "بطاقة إئتمان",
    paywhenreceivetheorder: "الدفع عند استلام الطلب",
    Greatwewillcontactyouassoonaspossible:
      "رائع، سوف نتواصل معك في أقرب وقت ممكن",
    Chooselanguage: "اختر اللغة",
    Pleasecreateaddress: "الرجاء إنشاء عنوان",
    Emptylist: "قائمة العناوين فارغة",
    Favorites: "المفضلة",
    Menu: "القائمة",
    thedealsuccessfullydone: "تمت العملية بنجاح",

    Pleasefillinallrequiredfields: "يرجى ملء جميع الخانات المطلوبة",
    UseCode: "استخدم الكود",
    OFF: "تخفيض",
    Used: "لقد قمت باستخدامة",
    Active: "لم تستخدمة",
    Getflat: " احصل على",
    offonyourpurchase: "خصم على مشترياتك. سارع، العرض ينتهي بعد!",
    CopyCode: "نسخ الكود",
    Copied: "تم النسخ",
    Orloginwith: "أو قم بتسجيل الدخول باستخدام",
    Subscribe: "اشتراك",
    Yes: "نعم",
    No: "لا",
    Characteristics: "صفات",
    Description: "وصف",
    areyousureyouwantcancelsubscription:
      "هل أنت متأكد أنك تريد إلغاء الاشتراك؟",
    AreyousureyouwanttodeletethisAddress:
      "هل أنت متأكد أنك تريد حذف هذا العنوان؟",
    Beautyclubdiscount: "تخفيض Beauty club",
    Pleaseaddthedeliveryaddresstocompletetheorder:
      "يرجى إضافة عنوان التسليم لاتمام الطلب",
    Youdonothaveadeliveryaddress: "ليس لديك عنوان تسليم",
    Pleaseaddadeliveryaddress: "الرجاء اضافة عنوان تسليم",
    Deliverywithindays: "التوصيل خلال 1 - 7 ايام",
    original: "اصلي",
    master: "ماستر",
  },
  profileOrderHistory: {
    Orderdetails: "تفاصيل الطلب",

    Orderid: "معرف الطلب",
    Totalprice: "السعر الإجمالي",
    Dateorder: "تاريخ الطلب",
    Timeorder: "وقت الطلب",
    Fullname: "الاسم الكامل",
    Phonenumber: "رقم الهاتف",
    city: "البلد",
    Street: "شارع",
    Building: "مبنى",
    Apartment: "شقة",
    ZIPcode: "الرمز البريدي",

    comment: "تعليق",
    Addressdetails: "تفاصيل العنوان",
    couponcode: "رمز القسيمة",
    Codeused: "الكود المستخدم",
    Discount: "تخفيض",
    ordered: "تم الطلب",
    withdeliveryman: "مع المرسل",
    delivered: "تم التوصيل",
    Pricebeforediscounts: "السعر قبل الخصومات",
    PricebeforePromocodeDiscount: "السعر قبل خصم الكوبون",
    Discountcouponcode: "تخفيض كود كوبون",
    delivery: "توصيل",
    GrandTotal: "المجموع الإجمالي",
    yousaved: "لقد وفرت",
    Price: "السعر",
    Free: "مجانا",
    paymenttype: "طريقة الدفع",
    Place: "عرعرة - المدخل الرئيسي الثاني (شارع الباطن)",
  },
  sentence: {
    Youcan: "تستطيع",
    emailus: "ارسال بريد الكتروني",
    callus: "الاتصال بنا",
    Contacts: "جهات الاتصال",
  },
  filters: {
    Brand: "ماركة",
    ProductType: "نوع المنتج",
    Classification: "تصنيف",
    ProductProperties: "خصائص المنتج",
    Gender: "الجنس",
    ScentType: "نوع الرائحة",
    TopNote: "خصائص الذروة",
    HeartNote: "ملاحظات متوسطة",
    BaseNote: "المكونات الأساسية",
    Ingredients: "مكونات",
    SpecialCertificates: "شهادات خاصة",
    Volume: "مقدار",
    MadeIn: "صنع في",
    Color: "لون",
    ProtectionLevel: "مستوى الحماية",
    EyeshadowEffect: "تأثير ظلال العيون",
    Formula: "صيغة التحضير",
    Country: "دولة",
    HairType: "نوع الشعر",
    BrushMaterial: "مادة الفرشاة",
    SkinType: "نوع البشرة",
    Age: "العمر",
    PriceRanges: "السعر",
  },
  longTexts: {
    InCheckOutForPromoCode:
      "أدخل رمز العرض الترويجي أو رمز العرض الترويجي الخاص في هذا الحقل للحصول على خصم أو هدية.",
    acceptTerms:
      "نعم، أوافق على شروط الاستخدام وسياسة الخصوصية الخاصة بـ Lemaq.",
    Youcanalways:
      "يمكنكم التواصل معنا دائمًا عبر رقم الهاتف الموضح في أعلى الموقع. كما يمكنكم إرسال طلباتكم/شكواكم/اقتراحاتكم عبر النموذج التالي.",

    OurStoryDisc:
      "أهلاً بكم في ليماك! بدأنا بشغف بسيط: تقديم مكياج عالي الجودة، خالٍ من القسوة، وبأسعار معقولة لعشاق الجمال في كل مكان. تأسست شركتنا عام ٢٠٢٤، وبدأت رحلتنا عندما لاحظ محمد شيخ عبد وجود فجوة في السوق في مجال محدد، مثل المكياج النباتي، والألوان الشاملة، والجمال المستدام. واليوم، نفخر بتقديم منتجات تُمكّنكِ من التعبير عن نفسكِ دون أي تنازلات.",
    Thankyouforsupporting:
      "شكرًا لدعمكم حلمنا. يسعدنا أن نكون جزءًا من رحلة جمالك!",
    QualityFirst:
      "الجودة أولاً: نقوم باختبار كل منتج بدقة للتأكد من أنه يلبي معاييرنا العالية.",
    CrueltyFree: "خالٍ من القسوة ونباتي: لم يتم إيذاء الحيوانات أبدًا.",
    Inclusivity: "الشمولية: مكياج لجميع ألوان البشرة وأنواعها وهوياتها.",
    Sustainability:
      "الاستدامة: التغليف الصديق للبيئة والمكونات ذات المصدر الأخلاقي.",
    AffordableLuxury: "✨ رفاهية بأسعار معقولة: جودة ممتازة دون سعر باهظ.",
    TrendDrivenTimeless:
      "💄 مدفوع بالاتجاهات وخالد: من الضروريات اليومية إلى الاتجاهات الجريئة.",
    FastReliableShipping:
      "🚚 شحن سريع وموثوق: لأن انتظار منتجات التجميل أمر صعب!",
  },
  delivery: {
    Youwill: "سوف تتلقى طردك إلى منزلك مع خدمة التوصيل Lemaq.",
    Thedelivery:
      "التوصيل مجاني للطلبات التي تزيد قيمتها عن 299 شيكل. للطلبات التي تقل قيمتها عن 299 شيكل، تكلفة التوصيل 19.90 شيكل.",
    Yourparcelwillbedeliveredonaveragewithin:
      "سيتم تسليم الطرد الخاص بك في المتوسط ​​خلال",
    workingdays: " 1-7 أيام عمل",
    fromthedate: "من تاريخ طلبك باستثناء عطلات نهاية الأسبوع والعطلات الرسمية.",
    Deliveryiscarried:
      "يتم التوصيل بعد استلام طلبك والدفع إلكترونيًا. يمكنك الدفع باستخدام بطاقات فيزا/ماستركارد عند إتمام عملية الشراء.",
    Aftertheorder:
      "بعد تقديم الطلب، سيقوم فريق خدمة العملاء لدينا بمعالجته. بعد تعبئة الطرد، سيتم تحويله إلى فريق التوصيل.",

    Youwillreceive:
      "ستصلك إشعارات عبر البريد الإلكتروني تتضمن تحديثات حالة الطلب ورقم تتبع الطرد.",
  },
  BeautyClub: {
    Welcometo: "مرحباً بكم في",
    wherebeautymeetssmartshopping: "حيث يلتقي الجمال بالتسوق الذكي.",
    Nowyoucanunlock:
      "الآن، يمكنكِ الاستفادة من خصومات حصرية ومزايا مميزة بالانضمام إلى نادي التجميل لدينا - اشتراك شهري",
    subscriptiondesignedformakeup: "اشتراك مصمم خصيصًا لمحبي المكياج مثلك.",
    WhyJointhe: "لماذا تنضم إلى",
    OFFeverysingle: "خصم على كل طلب - بلا حدود",
    The: "ال",
    OFFalsocomebeside:
      "هناك أيضًا خصومات بجانب العروض! مثلًا هناك عرض خصم 20%، ستحصل على خصم 30%!",

    Monthlysurprises:
      "مفاجآت شهرية - عينات فاخرة أو وصول مبكر للمنتجات الجديدة",
    Freeexpressshipping:
      "شحن سريع مجاني للطلبات التي تزيد عن 299 ₪ (حصريًا لنادي الجمال)",
    Membersonlydeals: "عروض وتخفيضات وحزم خاصة بالأعضاء فقط",
    Cancelanytimenolongtermcommitments:
      "إلغاء في أي وقت - لا توجد التزامات طويلة الأجل",

    RealExample: "مثال حقيقي",
    MatteLipstick: "أحمر شفاه غير لامع - 100 شيكل",
    Nonmember: "غير الأعضاء: 100 ₪",
    BeautyClubMember: "عضو نادي التجميل: ₪90 ✅",
    SkincareSet: "مجموعة العناية بالبشرة - 250 ₪",
    Nonmember250: "غير الأعضاء: ₪250",
    BeautyClubMember225: "عضو نادي التجميل: ₪225 ✅",
    Justtwoitemscan: "يمكن استخدام عنصرين فقط",
    saveyou35: "وفر ₪35+",
    inoneorderalone: "في طلب واحد فقط.",
    FrequentlyAskedQuestions: "الأسئلة الشائعة",
    WhathappensafterIsubscribe: "س: ماذا يحدث بعد الاشتراك؟",
    Youllinstantlyunlockyour: "ستحصل فورًا على خصم",
    discountandperks: "ومزايا إضافية. اشتراكك مرتبط بحسابك في LemaqStore.",
    CanIcancelanytime: "س: هل يمكنني إلغاء الاشتراك في أي وقت؟",
    YesYoucancancelyour:
      "نعم! يمكنك إلغاء اشتراكك في أي وقت من ملفك الشخصي. لا داعي لأي أسئلة.",
    Whatpaymentmethodsdoyousupport: "س: ما هي طرق الدفع التي تدعمها؟",
    Weacceptallmajor: "نقبل جميع بطاقات الائتمان الرئيسية. يتم الدفع شهريًا.",
    DoIneedtocommitforawholeyear: "س: هل يجب علي الالتزام لمدة عام كامل؟",
    NopeItsmonthlyStartorstopwheneveryoulike:
      "لا، إنه شهري. ابدأ أو أوقف متى شئت.",
    ReadytoSaveonEveryOrder: "هل أنت مستعد للتوفير في كل طلب؟",
    Jointhousandsofhappy:
      "انضم إلى الآلاف من عملاء LemaqStore السعداء الذين يتسوقون الآن بشكل أكثر ذكاءً.",
    JoinBeautyClubStartSaving: "[انضم إلى نادي الجمال - ابدأ التوفير]",
    OnlymonthCancelAnytimeOffEverything:
      "فقط ₪49/الشهر · إلغاء في أي وقت · خصم 10% على كل شيء",
    SUBSCRIBENOW: "اشترك الآن!",
    Pleaseloginfirst: "الرجاء تسجيل الدخول أولا",
    CANCELSUBSCRIBE: "إلغاء الاشتراك",
  },
};

const he = {
  navigation: {
    Aboutus: "עלינו",
    DeliveryandPayment: "משלוח ותשלום",
    Specialoffers: "מבצעים",
    FreeDeliveryover: "משלוח חינם מעל",
  },
  categories: {
    Perfumes: "בשמים",
    Makeup: "איפור",
    Hair: "שיער",
    Face: "פנים",
    BathandBody: "אמבט וניקוי גוף",
    ForMen: "לגברים",
    Accessories: "אקססוריז",
    HealthandCare: "בריאות",
    Gifts: "מתנות",
    Brands: "מותגים",

    //perfume
    WomenPerfumes: "בשמים לנשים",
    MenFragrances: "בשמים לגברים",
    UnisexPerfumes: "בשמים יוניסקס",
    KidsPerfumes: "בשמים לילדים",
    Sets: "ערכות",
    NichePerfumes: "בשמי נישה",
    ElitePerfumes: "בשמי בוטיק",
    FrenchPerfumes: "בשמים צרפתיים",
    DubaiPerfumes: "בשמים דובאי",
    Atomizers: "אוטומייזרים",
    HomeFragrances: "מפיצי ריח לבית",
    New: "חדש",
    SALE: "מבצעים!",
    ScentedCandles: "נרות מפיצי ריח",
    AromaLamps: "מנורות ארומה",
    Aromadiffusers: "מפזרי ריח",
    AromaSticks: "מקלות מפיצי ריח",
    AromaSprays: "תרסיסי ריח",
    ShowallPerfumes: "הצגת הכול ...",

    //end perfume

    //makeup
    Brows: "גבות",
    Eyes: "עיניים",
    Lips: "שפתיים",
    Face: "פנים",
    Brushes: "מברשות",
    MakeupRemovers: "הסרת איפור",
    Nails: "ציפורניים",
    MakeupPalettes: "ערכות איפור",
    PalettesandSets: "סטים וערכות",
    Professional: "איפור מקצועי",
    BrowPowders: "צלליות לגבות",
    BrowMascaras: "מסקרה לגבות",
    BrowPencils: "עפרונות לגבות",
    BrowGels: "ג'ל לגבות",
    BrowPomades: "פומייד לגבות",
    LashandBrowColorsTints: "צבע לגבות ולריסים",
    Mascara: "מסקרה",
    LashPrimers: "פריימר לריסים",
    EyePrimers: "בסיס מסקרה",
    Eyeshadows: "צלליות",
    EyelinerPencils: "עפרון עיניים",
    Eyeliners: "אייליינר",
    EyeConcealers: "קונסילרים לעיניים",
    LashandBrowCare: "טיפוח גבות וריסים",
    FalseEyelashes: "ריסים מלאכותיים",
    EyelashAdhesives: "דבק לריסים",
    Lipsticks: "שפתון",
    LipGlosses: "ליפגלוס",
    LipLiners: "עפרון שפתיים",
    LipTints: "פיגמנט לשפתיים",
    FacePrimers: "בסיס איפור",
    CCCreams: "קרם CC",
    BBCreams: "קרם BB",
    Blushes: "סמקים",
    Bronzers: "ברונזרים",
    Highlighters: "היילייטרים",
    IlluminatorsandShimmers: "שימרים",
    Concealers: "קונסילרים",
    FacePowders: "פודרה",
    Correctors: "קורקטורים",
    Foundations: "מייק אפ",
    NailPolishes: "לק ציפורניים",
    GelPolishes: "לק ג'ל",
    NailPolishBaseCoats: "בסיסים ללק",
    TopCoats: "מחזק ציפורניים",
    NailDesign: "קישוט ציפורניים",
    FakeNails: "ציפורניים מלאכותיות",
    NailDryTopCoats: "ייבוש לק",
    NailPolishRemovers: "מסירי לק",
    CuticleCare: "טיפוח בקיוטיקל",
    Treatment: "טיפול ציפורניים",
    ManicureandPedicureTools: "אביזרים למניקור ופדיקור",
    SpecialCareProducts: "מוצרים מיוחדים",
    //end makeup

    //hair
    Shampoos: "שמפו",
    HairRinses: "תרחיצים",
    HairBalms: "באלמים",
    Conditioners: "מרככים",
    HairMasks: "מסכות",
    ScalpExfoliation: "פילינגים לשיער",
    ScalpScrubs: "סקראבים",
    HairAmpoules: "אמפולות לשיער",
    HairLotions: "תחליבים",
    HairOils: "שמן לשיער",
    HairSerumsandFluids: "סרום לשיער",
    HairCreams: "קרמים לשיער",
    Sprays: "ספריי לשיער",
    Keratin: "קרטין",
    HairColouring: "צביעת השיער",
    HairStyling: "סטיילינג",
    BlondeHair: "שיער בלונדיני",
    HairAccessories: "אקססוריז לשיער",
    ForKids: "לילדים",
    HairProfessional: "טיפוח שיער מקצועי",
    DryShampoos: "שמפו יבש",
    SulfateFreeShampoos: "שמפו ללא סולפטים",
    AntiDandruffShampoos: "שמפו נגד קשקשים",
    SolidShampoos: "שמפו מוצק",
    CreamColours: "צבעי שיער",
    Powders: "אבקות שיער",
    Oxidants: "חמצן",
    Foam: "קצף שיער",
    Gels: "ג'ל לשיער",
    Clays: "חימר לשיער",
    Jelly: "ג'לי לשיער",
    Mousses: "מוס לשיער",
    WaxandGlue: "דבק ושעווה לשיער",
    Hairsprays: "ספריי עיצוב",
    Pastes: "משחות לשיער",
    PomadesandPowders: "פומדות ופודרות לשיער",
    HairBrushes: "מברשות ומסרקים",
    HairCurlers: "מסלסלי שיער",
    HairTiesandClips: "סיכות וגומיות",
    HairDryersCurlingIronsHairStraighteners: "מייבשים, מחליקים ומסלסלים",
    //end hair

    //face
    FaceCreams: "קרם פנים",
    FaceMasks: "מסכות פנים",
    FaceBalms: "באלם לפנים",
    FaceFluids: "פלוידים",
    SerumsElixirs: "סרום פנים",
    FaceOils: "שמן פנים",
    FaceCleansing: "ניקוי פנים",
    AntiAging: "אנטי אייג'ינג",
    Toning: "מוצרים מרעננים",
    Nourishing: "מוצרי הזנה",
    Moisturizing: "מוצרי לחות",
    SunProtection: "הגנה מהשמש",
    EyeCare: "טיפוח העיניים",
    LipCare: "טיפוח השפתיים",
    CleansingBrushes: "ספוגיות לניקוי הפנים",
    SpecialProducts: "מוצרי טיפוח מיוחדים",
    ShavingProductsforMen: "מוצרי גילוח לגברים",
    CleansingOils: "שמן הידרופילי",
    FaceProfessional: "טיפוח מקצועי",
    FaceConcentrates: "תרכיזים",
    FaceSerums: "סרום",
    FaceEmulsions: "אמולסיות",
    FaceMilk: "חלב לניקוי פנים",
    ScrubsPeelsExfoliators: "סקראבים ופילינגים",
    FaceToners: "טונרים",
    FaceFoams: "קצף לפנים",
    CleansingFaceGels: "ג'ל לניקוי הפנים",
    MicellarWater: "מים מיסלריים",
    CleansingOils: "שמן הידרופילי",
    SunscreenCreams: "קרם הגנה",
    SelfTanners: "שיזוף עצמי",
    EyeBalms: "באלמים לעיניים",
    EyePatches: "רטיות לעיניים",
    EyeGels: "ג'ל לעור מסביב לעיניים",
    EyeCreams: "קרם לעור מסביב לעיניים",
    LashSerums: "סרום לריסים",
    LipBalms: "שפתוני לחות לשפתיים",
    LipCreams: "קרם שפתיים",
    FaceSelfTanners: "שיזוף עצמי לפנים",
    //end face

    //BathAndBody
    BathandShower: "אמבט וניקוי גוף",
    OralCare: "היגיינת הפה",
    HairRemoval: "הסרת שיער",
    DeodorantsAntiperspirants: "דאודורנטים",
    BodyCare: "טיפוח הגוף",
    HandCare: "טיפוח הידיים",
    FootCare: "טיפוח הרגליים",
    HygieneandCareProducts: "היגיינה והגנה",
    CelluliteTreatment: "אנטי צלוליט",
    SunProtection: "הגנה מהשמש",
    EssentialOils: "שמנים אתריים",
    HomeFragrances: "ריחות לבית",
    GelsLotionsShowerMilk: "ג'לים, תרחיצים ותחליבים",
    Soap: "סבון",
    ScrubsExfoliators: "סקראבים ופילינגים",
    IntimateHygiene: "שטיפות להיגיינה נשית",
    BathSalt: "מלח אמבטיה",
    BathFoam: "קצף אמבט",
    BodyMud: "בוץ אמבטיה",
    Toothbrushes: "מברשות שיניים",
    InterdentalBrushes: "מברשות אינטרדנטליות",
    DentalFloss: "חוט דנטלי",
    ToothpastesToothpowdersGels: "משחות שיניים, אבקות וג'לים",
    Mouthwashes: "מי פה",
    Razors: "סכיני גילוח",
    WaxStrips: "רצועות שעווה להסרת שיער",
    CreamsLotionsBodyMilk: "קרמים ותחליבים",
    SerumsFluids: "סרום גוף",
    BodySpray: "תרסיסי גוף",
    BodyMasks: "מסכות לגוף",
    NeckandDecollete: "לצוואר ולדקולטה",
    BustCare: "טיפוח החזה",
    Deodorants: "דאודורנטים",
    Antiperspirants: "אנטיפרספירנט",
    MassageOils: "שמני עיסוי",
    Cleansing: "ניקוי הגוף",
    StretchMarkTreatment: "טיפול בסימני מתיחה",
    CreamsandLotions: "קרמים ותחליבים",
    HandGels: "ג'ל ידיים",
    MasksandScrubs: "מסכות וסקראבים",
    HandParaffin: "פראפין לידיים",
    NailCare: "מוצרים לציפורניים",
    CreamsLotions: "קרמים ותחליבים",
    DeodorantsAntiperspirants: "דאודורנטים",
    MasksandScrubs: "מסכות וסקראבים",
    SanitaryPads: "תחבושות היגייניות",
    Tampons: "טמפונים",
    ProtectiveMask: "מסכות הגנה",
    Wipes: "מגבונים",
    CottonBudsandPads: "פדים ומקלוני צמר גפן",
    ScentedCandles: "נרות ריחניים",
    AromaLamps: "מנורות ריחניות",
    ReedDiffusers: "מפזרי ריח",
    ReedRefills: "מקלות ריחניים",
    AromaSprays: "תרסיסי ריח",
    //end BathAndBody

    //for men
    Perfumes: "בשמים",
    Deodorants: "דאודורנטים",
    FaceandBodyCare: "טיפוח פנים וגוף",
    ShavingProducts: "מוצרי גילוח",
    HairCare: "טיפוח שיער",
    ToolsandAccessories: "אביזרים ואקססוריז",
    Foot: "רגליים",
    Hand: "ידיים",
    Body: "גוף",
    BeardCare: "טיפוח זקן",
    Razors: "סכיני גילוח",
    RazorBladeRefills: "להבים לסכיני גילוח",
    ShavingFoam: "קצף גילוח",
    ShavingGels: "ג'ל גילוח",
    ShavingCreams: "קרם גילוח",
    CleansingandNutrition: "ניקוי והזנה",
    HairStyling: "סטיילינג",
    Trimmers: "טרימרים",
    HairClippers: "מכונת תספורת",
    //end for men

    //accessories
    ForHair: "לשיער",
    ForMakeup: "לאיפור",
    HygieneandCare: "היגיינה וטיפוח",
    BathandBody: "אמבט וניקוי גוף",
    Mirrors: "מראות",
    BagsMakeupBags: "תיקים, תיקי איפור",
    Tweezers: "פינצטות",
    EyelashCurlers: "מעגלי ריסים",
    ManicureandPedicureTools: "אביזרים למניקור ופדיקור",
    HairRemoval: "להסרת שיער",
    Massagers: "מסאג'רים",
    HairBrushes: "מסרקים",
    HairTiesandClips: "סיכות וגומיות",
    HairdressingSupplies: "אביזרי תספורת",
    HairClippers: "מכונות תספורת",
    HairDryersCurlingIronsHairStraighteners: "מייבשים, מחליקים ומסלסלים",
    Brushes: "מברשות איפור",
    SpongesandApplicators: "ספוגיות איפור",
    PencilSharpeners: "מחדדים לעפרונות",
    CasesandBoxes: "נרתיקים",
    Wipes: "מגבונים",
    CottonPadsandBuds: "פדים ומקלוני צמר גפן",
    FaceCleansingSponge: "ספוגיות לניקוי הפנים",
    BathSponges: "ספוגי רחצה",
    Towels: "מגבות",
    ManicureTools: "אביזרי מניקור",
    PedicureTools: "אביזרי פדיקור",
    UVLEDNailLamps: "מנורות UV/LED",
    NailClippers: "קוצצי ציפורניים",
    NailFilesandBuffers: "פצירות",
    FacialMassagers: "מסאג'רים לפנים",
    BodyMassagers: "מסאג'רים לגוף",
    WomensBags: "תיקי נשים",
    womenswallet: "ארנק נשים",
    Setbags: "תיקים סט",
    Womenswatches: "שעוני נשים",
    Menswallet: "ארנק גברים",
    Labubu: "לבובו",
    Belt: "חגורה",

    //end accessories

    //health and Care
    NaturalandOrganicCosmetics: "קוסמטיקה טבעית ואורגנית",
    SexualWellnessProducts: "קוסמטיקה לנשים בהריון ולאמהות",
    PregnancyandMaternityProducts: "אביזרי מין",
    OralCare: "היגיינת הפה",
    Optics: "אופטיקה",
    NaturalCosmetics: "קוסמטיקה טבעית",
    OrganicCosmetics: "קוסמטיקה אורגנית",
    Toothbrushes: "מברשות שיניים",
    InterdentalBrushes: "מברשות אינטרדנטליות",
    DentalFloss: "חוט דנטלי",
    ToothpastesToothpowdersandGels: "משחות שיניים, אבקות וג'לים",
    Mouthwash: "מי פה",
    Contactlenses: "עדשות מגע",
    //end Health and Care

    //gifts
    GiftSets: "ערכות מתנה",
    GiftPackaging: "אריזות מתנה",
    GiftCards: "Gift Cards",
    GiftsforWomen: "מתנות לנשים",
    GiftsforMen: "מתנות לגברים",
    Offers: "מבצעי מותגים",
    LEMAQBeautyClub: "Lemaq Beauty Club",
    //end gifts
  },
  profile: {
    ContactInfo: "פרטים",
    AddressBook: "ספר כתובות",
    Orderhistory: "היסטוריית הזמנות",
    Wishlist: "רשימת משאלות",
    Promocodes: "קודי קידום",
    Logoff: "יציאה",
    Save: "שמור",
    Bethefirsttoknowaboutsalesandnewarrivals:
      "!יהיו הראשונים לדעת על מבצים ומוצרים חדשים",
    Contactus: "יצירת קשר",
    Termsofuse: "תנאי שימוש",
    Privacy: "מדיניות פרטיות",
    Shipping: "מדיניות משלוחים",
    Aboutourproducts: "מקוריות המוצרים",
    ReturnsandExchanges: "החלפה והחזרה",
    Articles: "בלוג",
    News: "מבצעים",
    Trackprice: "עקבו אחרי המחיר",
    Checkout: "לסיום הזמנה",
    Gotopay: "לך לתשלום",

    Orderprice: "סכום הזמנה",
    Totalamount: "סכום כללי",
    Cart: "סל",
    Yourorders: "ההזמנות שלכם",
    Next: "המשך",
    Subtotal: "סך הכל",
    Shipping: "משלוח (עד הבית שלך)",
    GrandTotal: "סך הכל",
    Buy: "לקנות",
    Callback: "שיחה חוזרת",
    Specialoffers: "מבצעים מיוחדים",
    Specialoffersfilter: "מסנן מבצעים מיוחדים",
    Filters: "מסננים",
    All: "הכול",
    AllCat: "כול ה",

    Login: "התחבר",
    Registration: "הרשמה",
    Recievenotificationsaboutnewarrivalssalesspecialoffers:
      "קבל הודעות על כניסות חדשות, מכירות, מבצעים מיוחדים",
    subscribe: "לעקוב",
    Forgotyourpassword: "שכחת את הסיסמה שלך?",
    morethan100000products: "יותר מ-100,000 מוצרים",
    Passwordrecovery: "שחזור סיסמא",
    Send: "שלח",
    Specialofferwillendin: "מבצע מיוחד יסתיים ב",
    days: "יום",
    and: "ו",
    Addanewaddress: "הוסף כתובת חדשה",
    Searchresults: "תוצאות חיפוש",
    Personalinfo: "מידע אישי",
    Deliverydetails: "פרטי משלוח",
    Deliveryaddress: "כתובת למשלוח",
    Recommended: "מומלצים",
    products: "מוצרים",
    Addacommenttotheorder: "הוסף הערה להזמנה",
    Ihaveapromocodeorcertificate: "יש לי קוד קופון או תעודה",
    Countinueshopping: "המשך קניות",
    Firstandlastname: "שם ושם משפחה",
    email: "E-mail",
    Password: "סיסמה",
    NewPassword: "סיסמה חדשה",
    Repeatpassword: "חזור על הסיסמה",
    Oldpassword: "סיסמה ישנה",
    Confirmpassword: "אשר את הסיסמה",

    Phone: "מספר טלפון",
    City: "עיר",
    Street: "רחוב",
    Pleaseloginfirsttopurchasethisproduct: "אנא היכנס תחילה כדי לרכוש מוצר זה.",
    Ok: "בסדר",

    Messagetext: "טקסט הודעה",

    Fullname: "שם מלא",

    Firstname: "שם",
    Lastname: "משפחה",
    Dateofbirth: "תאריך לידה",
    Countrynumber: "מספר מדינה",

    Sortby: "מיין לפי",
    Sort: "מיין",

    LeaveyourcommentAskaaquestion: "השאירו תגובה/שאלו שאלה",
    Yourrating: "הדירוג שלך",
    Youcanleavearevieworaskaquestion: "אתה יכול להשאיר ביקורת או לשאול שאלה",
    Pleaseloginfirsttopurchasethisproduct: "אנא התחבר תחילה כדי לרכוש מוצר זה.",
    Changeaddress: "הוסף או שנה כתובת",
    edit: "לערוך",
    WEWILLCALLYOUBACK: "!אנחנו נתקשר אליך בחזרה",
    WEAREALWAYSINTOUCH: "אנחנו תמיד בקשר!",
    Done: "שלח",
    DoneLang: "בסדר",

    SpecialOffersfrom: "הצעות מיוחדות מ",
    name: "שם",
    price: "מחיר",
    popularity: "פופולריות",
    lowtohigh: "סדר עולה",
    hightolow: "סדר יורד",
    Changecontactinfo: "שנה את פרטי הקשר",
    AllResults: "כל התוצאות",
    ClearAll: "נקה הכל",
    Clear: "לנקות",
    Apply: "ישם",

    Subject: "נושא",
    chooseadepartment: "לבחור מחלקה",
    partnership: "שותפות",
    markiting: "שיווק",
    customerservice: "שירות לקוחות",
    successfullysent: "נשלח בהצלחה!",
    OurStory: "הסיפור שלנו",
    OurMissionValues: "המשימה והערכים שלנו",
    WhyChooseUs: "למה לבחור בנו?",
    ThankYou: "תודה לך!",
    SunFri: "ראשון - שישי: 9:00 עד 21:00",
    Reviewson: "חוות הדעת על",
    Reviews: "חוות הדעת",

    Recentlyviewed: "נצפה לאחרונה",
    Less: "פחות מ",
    Morethan: "יותר מ",
    From: "מ ",
    To: "ל",
    ZIPCode: "מיקוד",
    Apt: "דירה",
    Building: "בניין",
    Enterpromocode: "הזן קוד קופון",
    Usepromocode: "השתמש בקוד קופון",
    CreditorDebitCardNumber: "מספר כרטיס אשראי*",
    ExpiryDate: "תאריך תפוגה*",
    Nameoncard: "השם בכרטיס*",
    MMYY: "חודש ושנה",
    Fullnameasoncard: "שם מלא כמו בכרטיס",
    PAY: "לשלם",
    Noordersfound: "לא נמצאו הזמנות",
    Doyouwantpaycashorcreditcard: "האם אתה רוצה לשלם במזומן או בכרטיס אשראי?",
    pleasechoosepaymentmethod: "אנא בחר שיטת תשלום",
    Freedeleviryover: "משלוח חינם מעל ₪199!",
    InStock: "במלאי",
    Outofstock: "לא במלאי",
    productID: "מזהה מוצר:",
    SimilarProducts: "מוצרים דומים",
    Cash: "מזומן",
    CreditCard: "כרטיס אשראי",
    paywhenreceivetheorder: "לשלם בעת קבלת ההזמנה",
    Greatwewillcontactyouassoonaspossible: "מעולה, ניצור איתך קשר בהקדם האפשרי",
    Chooselanguage: "בחר שפה",
    Pleasecreateaddress: "נא ליצור כתובת",
    Emptylist: "רשימת הכתובות ריקה.",
    Favorites: "מועדפים",
    Menu: "תפריט",
    thedealsuccessfullydone: "העסקה בוצעה בהצלחה",
    Pleasefillinallrequiredfields: "נא למלא את כל השדות הנדרשים.",
    UseCode: "השתמש בקוד",
    OFF: "הנחה",
    Used: "השתמשת בו",
    Active: "לא השתמשתה",
    Getflat: " קבל",
    offonyourpurchase: "הנחה על הרכישה שלך. מהרו, המבצע מסתיים אחרי!",
    CopyCode: "העתק קוד",
    Copied: "מועתק",
    Orloginwith: "או התחבר עם",
    Subscribe: "הירשם",
    Yes: "כן",
    No: "לא",
    Characteristics: "מאפיינים",
    Description: "תאור",
    areyousureyouwantcancelsubscription:
      "האם אתה בטוח שאתה רוצה לבטל את המנוי?",
    AreyousureyouwanttodeletethisAddress:
      "האם אתה בטוח שברצונך למחוק כתובת זו?",
    Beautyclubdiscount: "הנחת Beauty club",
    Pleaseaddthedeliveryaddresstocompletetheorder:
      "אנא הוסף את כתובת המשלוח כדי להשלים את ההזמנה.",
    Youdonothaveadeliveryaddress: "אין לך כתובת למשלוח.",
    Pleaseaddadeliveryaddress: "נא להוסיף כתובת למשלוח.",
    Deliverywithindays: "משלוח תוך 1-7 ימים",
    original: "מקורי",
    master: "מאסטר",
  },
  profileOrderHistory: {
    Orderdetails: "פרטי הזמנה",
    Orderid: "מזהה הזמנה",
    Totalprice: "מחיר כולל",
    Dateorder: "תאריך ההזמנה",
    Timeorder: "זמן ההזמנה",
    Fullname: "שם מלא",
    Phonenumber: "מספר טלפון",
    city: "עיר",
    Street: "רחוב",
    Building: "בנין",
    Apartment: "דירה",
    ZIPcode: "מיקוד",

    comment: "הערה",
    Addressdetails: "פרטי כתובת",
    couponcode: "קוד קופון",
    Codeused: "נעשה שימוש בקוד",
    Discount: "הנחה",
    ordered: "ההזמנה בוצעה",
    withdeliveryman: "עם שליח",
    delivered: "נמסר",
    Pricebeforediscounts: "מחיר לפני הנחות",
    PricebeforePromocodeDiscount: "מחיר לפני הנחת קופון",
    Discountcouponcode: "הנחת קוד קופון",
    delivery: "משלוח",
    GrandTotal: "סך הכל",
    yousaved: "שמרת",
    Price: "מחיר",
    Free: "חינם",
    paymenttype: "אמצעי תשלום",
    Place: "ערערה - כניסה ראשית שנייה (רחוב אל-באטין)",
  },
  sentence: {
    Youcan: "אתה יכול",
    emailus: "שתשלח מייל",
    callus: "צור קשר איתנו",
    Contacts: "קשר",
  },
  filters: {
    Brand: "מותג",
    ProductType: "קבוצת מוצרים",
    Classification: "סיווג",
    ProductProperties: "תכונות",
    Gender: "מין",
    ScentType: "סוג ריח",
    TopNote: "תווי פסגה",
    HeartNote: "תווי ביניים",
    BaseNote: "תווי בסיס",
    Ingredients: "מרכיבים",
    SpecialCertificates: "תעודות מיוחדות",
    Volume: "תכולה",
    MadeIn: "מיטצר ב",
    Color: "צבע",
    ProtectionLevel: "רמת הגנה",
    EyeshadowEffect: "אפקט צללית",
    Formula: "פורמולת התכשיר",
    Country: "המדינה",
    HairType: "סוג שיער",
    BrushMaterial: "חומר מברשת",
    SkinType: "סוג עור",
    Age: "גיל",
    PriceRanges: "מחיר",
    Newuserregistration: "רישום משתמש חדש",
  },
  longTexts: {
    InCheckOutForPromoCode:
      "הזן את קוד ההטבה או את קוד ההטבה המיוחד בשדה זה כדי לקבל הנחה או מתנה.",
    acceptTerms: "כן, אני מקבל את תנאי השימוש ומדיניות הפרטיות של Lemaq.",
    Youcanalways:
      "אתה תמיד יכול ליצור איתנו קשר באמצעות מספר הטלפון המצוין בכותרת של האתר. אתה יכול גם לשלוח את בקשתך/תלונה/הצעה באמצעות הטופס הבא.",

    OurStoryDisc:
      "ברוכים הבאים ל-Lemaq! התחלנו עם תשוקה פשוטה: להביא איפור איכותי, נטול אכזריות ובמחיר סביר לאוהבי יופי בְּכָל מָקוֹם. נוסדה בשנת 2024, המסע שלנו התחיל כשמוחמד שח abed הבחין בפער בשוק עבור נישה ספציפית, למשל, טבעוני איפור, גוונים כוללים, יופי בר קיימא. היום, אנחנו גאים להציע מוצרים שמעצימים אותך להביע את עצמך - בלי פְּשָׁרָה.",
    Thankyouforsupporting:
      "תודה שתמכת בחלום שלנו. אנחנו נרגשים להיות חלק ממסע היופי שלך!",
    QualityFirst:
      "איכות ראשונה: אנו בודקים בקפדנות כל מוצר כדי להבטיח שהוא עומד הסטנדרטים הגבוהים שלנו.",
    CrueltyFree: "ללא אכזריות וטבעוני: אף חיות לא נפגעו - מעולם.",
    Inclusivity: "הכללה: איפור לכל גווני העור, סוגיו והזהויות.",
    Sustainability: "קיימות: אריזה ידידותית לסביבה ומרכיבים מוסריים.",
    AffordableLuxury: "✨ יוקרה במחיר סביר: איכות פרימיום ללא תג מחיר גבוה.",
    TrendDrivenTimeless:
      "💄 מונע על ידי טרנדים וחסר זמן: ממרכיבים בסיסיים יומיומיים ועד לטרנדים נועזים.",

    FastReliableShipping: "🚚 משלוח מהיר ואמין: כי קשה לחכות ליופי!",
  },
  delivery: {
    Youwill: "תקבל את החבילה שלך עד הבית עם Lemaq Delivery.",
    Thedelivery:
      "המשלוח חינם בהזמנות מעל ₪299. להזמנות מתחת ל-299 ₪ ה עלות משלוח 19.90 ₪.",
    Yourparcelwillbedeliveredonaveragewithin: "החבילה שלך תסופק בממוצע בתוך",
    workingdays: "1-7 ימי עבודה",
    fromthedate: "מתאריך ההזמנה שלך לא כולל סופי שבוע וחגים.",
    Deliveryiscarried:
      "המשלוח מתבצע לאחר קבלת ההזמנה והתשלום שלך באינטרנט. אתה יכול לשלם עבור ההזמנה שלך באמצעות VISA/Mastercard, במהלך קופה.",
    Aftertheorder:
      "לאחר ביצוע ההזמנה, שירות הלקוחות שלנו יעבד אותה. פַּעַם החבילה ארוזה היא תועבר לצוות המשלוח.",
    Youwillreceive:
      "תקבל הודעות דואר אלקטרוני עם עדכוני סטטוס ההזמנה ומספר המעקב של החבילה.",
  },

  BeautyClub: {
    Welcometo: "ברוכים הבאים ל",
    wherebeautymeetssmartshopping: "שבו יופי פוגש קניות חכמות.",
    Nowyoucanunlock:
      "עכשיו, אתה יכול לפתוח חסכון בלעדיים והטבות פרימיום על ידי הצטרפות למועדון היופי שלנו - חודשי",
    subscriptiondesignedformakeup: "מנוי המיועד לאוהבי איפור כמוך.",
    WhyJointhe: "למה להצטרף ל",
    OFFeverysingle: "הנחה על כל הזמנה - ללא הגבלה",
    The: "ה",
    OFFalsocomebeside:
      "OFF בוא גם לצד הצעות! כמו שיש מבצע של 20% הנחה, תקבל 30% הנחה!",
    Monthlysurprises:
      "הפתעות חודשיות - דוגמאות מפוארות או גישה מוקדמת למגיעים חדשים",
    Freeexpressshipping:
      "משלוח אקספרס חינם בהזמנות מעל ₪299 (בלעדי למועדון היופי)",
    Membersonlydeals: "מבצעים, מכירות וחבילות לחברים בלבד",
    Cancelanytimenolongtermcommitments:
      "בטל בכל עת - ללא התחייבויות לטווח ארוך",
    RealExample: "דוגמה אמיתית",
    MatteLipstick: "שפתון מאט – ₪100",
    Nonmember: "לא חבר: 100 ₪",
    BeautyClubMember: "חבר במועדון ביוטי: ₪90 ✅",
    SkincareSet: "סט טיפוח – ₪250",
    Nonmember250: "לא חבר: 250 ₪",
    BeautyClubMember225: "חבר במועדון ביוטי: ₪225 ✅",
    Justtwoitemscan: "רק שני פריטים יכולים",
    saveyou35: "חוסך לך ₪35+",
    inoneorderalone: "בהזמנה אחת בלבד.",
    FrequentlyAskedQuestions: "שאלות נפוצות",
    WhathappensafterIsubscribe: "ש: מה קורה אחרי שאני מנוי?",
    Youllinstantlyunlockyour: "אתה תפתח מיידית את ה-",
    discountandperks: "שלך הנחה והטבות. המנוי שלך קשור לחשבון LemaqStore שלך.",
    CanIcancelanytime: "ש: האם אני יכול לבטל בכל עת?",
    YesYoucancancelyour:
      "כן! אתה יכול לבטל את המנוי שלך בכל עת מהפרופיל שלך. לא נשאלו שאלות.",
    Whatpaymentmethodsdoyousupport: "ש: באילו אמצעי תשלום אתה תומך?",
    Weacceptallmajor:
      "אנו מקבלים את כל כרטיסי האשראי הגדולים. התשלום מחויב מדי חודש.",
    DoIneedtocommitforawholeyear: "ש: האם אני צריך להתחייב לשנה שלמה?",
    NopeItsmonthlyStartorstopwheneveryoulike:
      "לֹא. זה חודשי. התחל או עצור מתי שתרצה.",
    ReadytoSaveonEveryOrder: "מוכן לחסוך בכל הזמנה?",
    Jointhousandsofhappy:
      "הצטרפו לאלפי לקוחות מרוצים של LemaqStore שעכשיו קונים בצורה חכמה יותר.",
    JoinBeautyClubStartSaving: "[הצטרף למועדון היופי - התחל לחסוך]",
    OnlymonthCancelAnytimeOffEverything:
      "רק ₪49/חודש · ביטול בכל עת · 10% הנחה על הכל",
    SUBSCRIBENOW: "הירשם עכשיו!",
    Pleaseloginfirst: "אנא התחבר תחילה",
    CANCELSUBSCRIBE: "בטל הרשמה",
  },
};

const resources = {
  en: {
    translation: en,
  },

  ar: {
    translation: ar,
  },
  he: {
    translation: he,
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
